// components/StickyBookingInfoBox.jsx
import { StarIcon } from "@heroicons/react/24/solid"; // Full star
import { StarIcon as StarOutline } from "@heroicons/react/24/outline"; // for empty stars

const StickyInfoBox = ({ operator }) => {
  if (!operator) return null;

  const {
    name,
    address,
    openHour = "8:00 pm",
    isFeatured = true,
    rating = "5.0",
    reviewCount = 1918,
  } = operator;

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.3 && rating % 1 <= 0.7;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="flex space-x-1 text-yellow-500">
        {[...Array(fullStars)].map((_, i) => (
          <StarIcon key={`full-${i}`} className="w-3 h-3" />
        ))}
        {hasHalfStar && (
          <div className="relative w-3 h-3">
            <StarIcon className="absolute w-3 h-3 text-yellow-500" />
            <div className="absolute top-0 right-0 w-1.5 h-3 bg-dry" />
          </div>
        )}
        {/* Optional: show empty stars */}
        {[...Array(emptyStars)].map((_, i) => (
          <StarOutline key={`empty-${i}`} className="w-3 h-3" />
        ))}
      </div>
    );
  };
  return (
    <div className="w-full md:w-[300px] lg:w-[300px] sticky top-24 self-end bg-dry rounded-xl shadow-lg border border-border p-6 text-sm">
      <h2 className="text-xl font-bold text-text">{name}</h2>

      <div className="flex items-center mt-1 text-text">
        <span className="font-semibold mr-2">{rating}</span>
        <span className="text-yellow-500">{renderStars(rating)}</span>
        <a href="#reviews" className="ml-2 text-blue-600 hover:underline">
          ({reviewCount})
        </a>
      </div>

      {isFeatured && (
        <span className="inline-block mt-2 text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded-full">
          Featured
        </span>
      )}

      <button className="w-full mt-4 bg-black text-white py-2 rounded hover:bg-gray-900">
        Book now
      </button>

      <div className="mt-6 border-t pt-4 text-sm">
        <p className="flex items-center gap-2 text-green-600">
          🕒 Open until {openHour}
        </p>
        <p className="mt-2 flex items-start gap-2">
          📍
          <span>
            {address}
            <br />
            <a href="#" className="text-blue-600 underline">
              Get directions
            </a>
          </span>
        </p>
      </div>

      <div className="mt-6 bg-drylight p-3 rounded-lg flex justify-between items-center">
        <div>
          <p className="font-medium">Gift Cards</p>
          <p className="text-xs text-textGray">Treat yourself or a friend.</p>
        </div>
        <button className="border px-3 py-1 rounded text-sm hover:bg-textGray">
          Buy
        </button>
      </div>
    </div>
  );
};

export default StickyInfoBox;
